import { InnerBox } from "@/components/elements/InnerBox";
import { Grid, Stack } from "@mui/material";
import { FC } from "react";
import { JobFormTitle } from "@/features/job/components/job-form/JobFormTitle";
import { TJobForm } from "@/features/job/types/JobForm";
import { useEnum } from "@/api/services/global/enum";
import { JobInfoItem } from "@/features/job/components/job-detail/JobInfoItem";
import { findLabelByValue } from "@/utils/object";
import { convertNumberToCommas } from "@/utils/input";

type TJobEmploymentConditionDetailProps = {
  defaultValues?: Partial<TJobForm>;
  isDraft ?: boolean,
};

export const JobEmploymentConditionDetail: FC<TJobEmploymentConditionDetailProps> = ({ defaultValues, isDraft }) => {
  const { data: employmentTypeOptions } = useEnum("EEmploymentType");
  const { data: salaryTypeOptions } = useEnum("ESalaryType");
  const { data: yesNoPendingStatusOptions } = useEnum("EYesNoPendingStatus");

  return (
    <Stack gap={2}>
      <InnerBox title={<JobFormTitle text="雇用条件" />} padding="24px" showDivider={false}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <JobInfoItem label="業務内容" value={defaultValues?.businessContent} />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="雇用形態" value={findLabelByValue(employmentTypeOptions, defaultValues?.employmentType)} required={!isDraft} />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="給与形態" value={findLabelByValue(salaryTypeOptions, defaultValues?.salaryType)} />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="基本給" value={defaultValues?.baseSalary !== null && defaultValues?.baseSalary !== undefined ? `${convertNumberToCommas(defaultValues.baseSalary.toString())}円` : ""} required={!isDraft} />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="総支給額" value={defaultValues?.totalAmount !== null && defaultValues?.totalAmount !== undefined  ? `${convertNumberToCommas(defaultValues.totalAmount.toString())}円` : ""} />
          </Grid>
          <Grid item xs={12}>
            <JobInfoItem label="総支給額の内訳" value={defaultValues?.totalAmountBreakdown} />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="目安手取り金額" value={defaultValues?.netSalaryEstimate !== null && defaultValues?.netSalaryEstimate !== undefined ? `${convertNumberToCommas(defaultValues.netSalaryEstimate.toString())}円` : ""} />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="給与控除" value={defaultValues?.salaryDeductions} />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="1時間あたりの給与" value={defaultValues?.hourlyWage !== null && defaultValues?.hourlyWage !== undefined ? `${convertNumberToCommas(defaultValues.hourlyWage.toString())}円` : ""} />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="その他手当の金額" value={defaultValues?.otherAllowanceAmount !== null && defaultValues?.otherAllowanceAmount !== undefined ? `${convertNumberToCommas(defaultValues.otherAllowanceAmount.toString())}円` : ""} />
          </Grid>
          <Grid item xs={12}>
            <JobInfoItem label="その他手当の内容" value={defaultValues?.otherAllowanceDescription} />
          </Grid>
          <Grid item xs={12}>
            <JobInfoItem label="残業に関する説明" value={defaultValues?.overtimeDescription} />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="賞与" value={findLabelByValue(yesNoPendingStatusOptions, defaultValues?.bonus)} required={!isDraft} />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="賞与時期・金額" value={defaultValues?.bonusInfo} />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="昇給" value={findLabelByValue(yesNoPendingStatusOptions, defaultValues?.salaryRaise)} required={!isDraft} isShowDivider={false} />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="昇給時期" value={defaultValues?.salaryRaiseTime} isShowDivider={false} />
          </Grid>
        </Grid>
      </InnerBox>
    </Stack>
  );
};
